export default __webpack_public_path__ + "static/media/logo.2484a6b9.png";